<section *ngIf="status() as current" class="business-status" [attr.aria-label]="title()">
  <div class="business-status__current">
    <span class="business-status__label">{{ title() }}</span>
    <strong>{{ current.label || 'No status set' }}</strong>
  </div>
  <div *ngIf="manualChangesAllowed(); else readOnly" class="business-status__controls">
    <ui-form
      [config]="pickerConfig()"
      [formValues]="pickerValue()"
      [disabled]="controlsDisabled()"
      [useAutoSave]="false"
      subscriptSizing="dynamic"
      (formValuesChange)="select($event)"
      (formSubmitted)="changeStatus()"
    />
    <ui-button
      [buttonText]="busy() ? 'Changing…' : 'Change status'"
      severity="secondary"
      [outlined]="true"
      [disabled]="!canChange()"
      (click)="changeStatus()"
    />
  </div>
  <p *ngIf="manualChangesAllowed() && disabled() && disabledReason()" class="business-status__hint">{{ disabledReason() }}</p>
  <ng-template #readOnly><p class="business-status__hint">{{ readOnlyHint() }}</p></ng-template>
  <div *ngIf="errorMessages().length" class="business-status__error" role="alert">
    <strong>{{ title() }} could not be changed</strong>
    <p *ngFor="let message of errorMessages()">{{ message }}</p>
    <p *ngIf="supportReference()">Support reference: {{ supportReference() }}</p>
  </div>
  <ui-button *ngIf="refreshRequired()" buttonText="Refresh status" severity="secondary" [outlined]="true"
    [disabled]="busy() || confirming() || disabled()" (click)="refresh()" />
</section>
